import React from 'react'
import {isPicked} from '../afa-shared'

// same matching rule as getModifierPrice in calcItemPriceArray, so what the
// customer sees can't disagree with what the cart charges.
export const resolveModifierPrice = ({price, priceIf}, customerPicks = {}) => {
  if (Array.isArray(priceIf)) {
    let result = priceIf.find(({match}) => isPicked(customerPicks[match]))
    return result && result.price || null
  }
  return price || null
}

const Price = ({modifier, customerPicks, priceDiv}) => {
  let priceDisplay = resolveModifierPrice(modifier, customerPicks)

  if (Number(priceDiv)) { priceDisplay = Number(priceDisplay) / Number(priceDiv) }

  return priceDisplay ? <span className="price">+${priceDisplay}</span> : null
}

export default Price
